import useScrollFade from '../../../hooks/useScrollFade';

const challenges = [
  {
    icon: 'ri-funds-line',
    text: 'Software projects running over budget',
    iconColor: 'text-blue-500',
    iconBg: 'bg-blue-50',
    iconBorder: 'border-blue-100',
  },
  {
    icon: 'ri-team-line',
    text: 'Difficulty managing development teams',
    iconColor: 'text-blue-500',
    iconBg: 'bg-blue-50',
    iconBorder: 'border-blue-100',
  },
  {
    icon: 'ri-user-star-line',
    text: 'Lack of senior engineering leadership',
    iconColor: 'text-blue-500',
    iconBg: 'bg-blue-50',
    iconBorder: 'border-blue-100',
  },
  {
    icon: 'ri-stack-line',
    text: 'Architecture decisions that impact scalability',
    iconColor: 'text-blue-500',
    iconBg: 'bg-blue-50',
    iconBorder: 'border-blue-100',
  },
  {
    icon: 'ri-currency-line',
    text: 'Cost control and budget efficiency',
    iconColor: 'text-blue-500',
    iconBg: 'bg-blue-50',
    iconBorder: 'border-blue-100',
  },
  {
    icon: 'ri-database-2-line',
    text: 'Legacy systems slowing development',
    iconColor: 'text-blue-500',
    iconBg: 'bg-blue-50',
    iconBorder: 'border-blue-100',
  },
];

const ProblemSection = () => {
  const header = useScrollFade();
  const intro = useScrollFade({ delay: 80 });
  const list = useScrollFade({ delay: 160 });
  const conclusion = useScrollFade({ delay: 240 });

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          ref={header.ref}
          className={`text-center mb-12 ${header.fadeClass}`}
        >
          <h3 className="text-blue-600 text-sm font-bold uppercase tracking-wider mb-3">
            The Challenge
          </h3>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
            When Companies Need a Fractional CTO
          </h2>
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="h-px w-16 bg-gray-200" />
            <div className="h-0.5 w-10 rounded-full bg-blue-400 shadow-[0_0_8px_rgba(59,130,246,0.6)]" />
            <div className="h-px w-16 bg-gray-200" />
          </div>
        </div>

        <div className="max-w-5xl mx-auto">
          <div
            ref={intro.ref}
            className={`text-gray-700 text-lg leading-relaxed mb-10 text-center ${intro.fadeClass}`}
          >
            <p className="max-w-[700px] mx-auto text-gray-700 text-lg leading-relaxed mb-1">
              Many growing companies reach a point where technology becomes a bottleneck. You may be facing challenges such as:
            </p>
            {/* <p className="text-gray-700 text-lg leading-relaxed">
              You may be facing challenges such as:
            </p> */}
          </div>

          <div
            ref={list.ref}
            className={`mb-10 ${list.fadeClass}`}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {challenges.map((challenge, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 bg-white rounded-xl px-5 py-4 border border-gray-100 shadow-sm hover:shadow-md hover:border-gray-200 transition-all duration-300"
                >
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${challenge.iconBg} border ${challenge.iconBorder} flex-shrink-0`}>
                    <i className={`${challenge.icon} text-xl ${challenge.iconColor}`}></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-snug font-medium">
                    {challenge.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div
            ref={conclusion.ref}
            className={`bg-gradient-to-r from-blue-600 to-sky-500 rounded-2xl p-8 shadow-lg ${conclusion.fadeClass}`}
          >
            <p className="text-white text-lg leading-relaxed text-center">
              A fractional CTO provides <strong className="text-white underline decoration-white/40 underline-offset-2">experienced technology leadership</strong> without the cost of a full-time executive.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;